<template>
    <div>
        <v-btn
            v-if="can('api.v1.consultants.update') || can('api.v1.consultants.store')"
            color="primary"
            rounded
            large
            :disabled="disabled"
            :loading="consultantsFormLoading"
            class="mr-5"
            @click="saveConsultant()"
        >
            {{ isAdmin ? t('consultants::button.submit') : t('consultants::button.send_save_request') }}</v-btn
        >
    </div>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            consultantsFormLoading: false,
        };
    },
    computed: {
        id() {
            return this.$store.state.consultants.consultant.id;
        },
        isAdmin() {
            return User.group === 'admins';
        },
    },
    methods: {
        async saveConsultant() {
            this.consultantsFormLoading = true;
            this.$store.dispatch('consultants/resetErrorMessages');
            axios({
                method: this.id ? 'put' : 'post',
                url: this.id
                    ? route('api.v1.consultants.update', { consultant: this.id })
                    : route('api.v1.consultants.store'),
                data: this.$store.state.consultants.consultant,
            })
                .then(() => {
                    _.delay(() => {
                        this.$root.goTo(route('consultants.index'));
                    }, 1000);
                    if (!this.id) {
                        if (this.isAdmin) {
                            return this.$root.notify(
                                'info',
                                t('consultants::notification.success'),
                                t('consultants::notification.consultant.created')
                            );
                        } else {
                            return this.$root.notify(
                                'info',
                                t('consultants::notification.success'),
                                t('consultants::notification.consultant.send_approval')
                            );
                        }
                    }
                    if (this.id) {
                        if (this.isAdmin) {
                            return this.$root.notify(
                                'info',
                                t('consultants::notification.success'),
                                t('consultants::notification.consultant.update')
                            );
                        } else {
                            return this.$root.notify(
                                'info',
                                t('consultants::notification.success'),
                                t('consultants::notification.consultant.send_approval')
                            );
                        }
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('consultants/setErrorMessages', error.response.data.errors);
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => _.delay(() => (this.consultantsFormLoading = false), 1400));
        },
    },
};
</script>

<style></style>
